import { showUpgradeModal } from "../components/upgrade_modal";

export function initTestLobby(): void {
  initModeToggle();
  initAnswerCards();
  initCooldownTimer();
}

function initModeToggle(): void {
  const container = document.querySelector<HTMLElement>(
    '[data-controller="test-lobby"]',
  );
  const modeInput = document.getElementById(
    "test-mode-input",
  ) as HTMLInputElement;
  const modeBtns = document.querySelectorAll<HTMLElement>("[data-mode]");
  const eloSection = document.querySelector<HTMLElement>("[data-elo-section]");

  if (!modeInput || modeBtns.length === 0) return;

  const isRankedLocked =
    container?.dataset.testLobbyRankedLockedValue === "true";
  const defaultMode = container?.dataset.testLobbyDefaultModeValue || "ranked";

  modeBtns.forEach((btn) => {
    btn.addEventListener("click", () => {
      const clickedMode = btn.dataset.mode || "ranked";

      if (clickedMode === "ranked" && isRankedLocked) {
        showUpgradeModal();
        return;
      }

      modeBtns.forEach((el) => {
        const mode = el.dataset.mode;
        el.classList.remove("active");

        if (mode === "practice") {
          el.classList.remove("border-teal-500", "bg-teal-500/20");
          el.classList.add("border-teal-700", "bg-teal-900/20");
          const label = el.querySelector("div:first-of-type");
          if (label) label.classList.replace("text-white", "text-teal-300");
          const sublabel = el.querySelector("div:last-child");
          if (sublabel)
            sublabel.classList.replace("text-teal-300", "text-teal-500");
        } else if (mode === "ranked") {
          el.classList.remove("border-blue-500", "bg-blue-500/10");
          el.classList.add("border-blue-700", "bg-blue-900/20");
          const label = el.querySelector("div:first-of-type");
          if (label) label.classList.replace("text-white", "text-blue-300");
          const sublabel = el.querySelector("div:last-child");
          if (sublabel)
            sublabel.classList.replace("text-blue-300", "text-blue-500");
        }
      });

      btn.classList.add("active");

      if (clickedMode === "practice") {
        btn.classList.remove("border-teal-700", "bg-teal-900/20");
        btn.classList.add("border-teal-500", "bg-teal-500/20");
        const label = btn.querySelector("div:first-of-type");
        if (label) label.classList.replace("text-teal-300", "text-white");
        const sublabel = btn.querySelector("div:last-child");
        if (sublabel)
          sublabel.classList.replace("text-teal-500", "text-teal-300");
      } else if (clickedMode === "ranked") {
        btn.classList.remove("border-blue-700", "bg-blue-900/20");
        btn.classList.add("border-blue-500", "bg-blue-500/10");
        const label = btn.querySelector("div:first-of-type");
        if (label) label.classList.replace("text-blue-300", "text-white");
        const sublabel = btn.querySelector("div:last-child");
        if (sublabel)
          sublabel.classList.replace("text-blue-500", "text-blue-300");
      }

      modeInput.value = clickedMode;

      if (eloSection) {
        if (clickedMode === "ranked") {
          eloSection.style.display = "block";
        } else {
          eloSection.style.display = "none";
        }
      }
    });
  });

  if (eloSection && defaultMode === "practice") {
    eloSection.style.display = "none";
  }
}

function initAnswerCards(): void {
  const answerCards = document.querySelectorAll<HTMLElement>(".answer-card");

  if (answerCards.length === 0) return;

  answerCards.forEach((card) => {
    card.addEventListener("click", () => {
      answerCards.forEach((el) => {
        el.classList.remove("selected");
        const icon = el.querySelector(".status-icon");
        if (icon) {
          icon.className =
            "w-8 h-8 rounded-full border-2 border-gray-500 group-hover:border-blue-400 flex items-center justify-center text-sm font-bold text-gray-400 group-hover:text-blue-400 transition status-icon";
        }
      });

      card.classList.add("selected");
      const icon = card.querySelector(".status-icon");
      if (icon) {
        icon.className =
          "w-8 h-8 rounded-full border-2 border-blue-500 bg-blue-500 flex items-center justify-center text-sm font-bold text-white shadow-lg status-icon";
      }
    });
  });
}

export function initCooldownTimer(): void {
  const cooldownEl = document.querySelector<HTMLElement>(
    '[data-controller="cooldown-timer"]',
  );
  if (!cooldownEl) return;

  const endsAtStr = cooldownEl.dataset.cooldownTimerEndsAtValue;
  if (!endsAtStr) return;

  const endsAt = new Date(endsAtStr);
  const timerEl = cooldownEl.querySelector<HTMLElement>(
    '[data-cooldown-timer-target="timer"]',
  );
  if (!timerEl) return;

  const updateTimer = (): void => {
    const now = new Date();
    const diffMs = endsAt.getTime() - now.getTime();

    if (diffMs <= 0) {
      timerEl.textContent = "00:00";
      setTimeout(() => {
        window.location.reload();
      }, 1000);
      return;
    }

    const minutes = Math.floor(diffMs / 60000);
    const seconds = Math.floor((diffMs % 60000) / 1000);
    timerEl.textContent = `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
  };

  updateTimer();
  const intervalId = setInterval(updateTimer, 1000);

  document.addEventListener(
    "turbo:before-cache",
    () => {
      clearInterval(intervalId);
    },
    { once: true },
  );
}

document.addEventListener("turbo:load", () => {
  if (document.querySelector('[data-controller="test-lobby"]')) {
    initTestLobby();
  }

  // Cooldown timer is independent - may appear without test-lobby
  initCooldownTimer();
});
